export default function LightboxLoader() {
    return (
        <div className='w-full h-full flex items-center justify-center'>
            <div className='flex flex-col items-center justify-center opacity-20 gap-3'>
                <img className='w-20 h-20' alt='Budapest Főváros VI. kerület Terézváros Polgármesteri Hivatal' src='/assets/images/logo/shield-outline-white.svg' />
                <p className='text-sm font-bold text-tv-gray tracking-wider uppercase'>Betöltés...</p>
            </div>
        </div>
    )
}